<template>
  <DxPopup
    :visible="visible"
    :show-close-button="true"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :width="420"
    :height="'auto'"
    :shading="true"
    :show-title="true"
    :title="$t('info')"
    :toolbar-items="toolbarItems"
    @hiding="handleClose"
  >
    <div class="expiration-popup">
      <div class="expiration-popup-row">
        <strong>{{ $t('common.name') }}:</strong>
        <span>{{ data?.name || '-' }}</span>
      </div>
      <div class="expiration-popup-row">
        <strong>{{ $t('common.expiration_date') }}:</strong>
        <span>{{ data?.date || '-' }}</span>
      </div>
      <div class="expiration-popup-row">
        <strong>{{ $t('works.work_machines.days_remaining') }}:</strong>
        <span>{{ data?.daysRemaining }}</span>
      </div>
      <div class="expiration-popup-row">
        <strong>{{ $t('remark') }}:</strong>
        <span>{{ data?.notes || '-' }}</span>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";

export default {
  name: "WorkMachineExpirationPopup",
  components: { DxPopup },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({ name: "", date: "", notes: "", daysRemaining: "" }),
    },
  },
  computed: {
    toolbarItems() {
      return [
        {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: {
            text: this.$t("common.close"),
            type: "normal",
            onClick: this.handleClose,
          },
        },
      ];
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.expiration-popup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.expiration-popup-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.expiration-popup-row strong {
  min-width: 120px;
}
</style>
